import React from 'react'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import RostersTable from './Componates/RostersTable';

const RosterList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Duty Roster List</HeadingOne>
                    <AddItemBtn url="add-roster" title="Create Roster" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <RostersTable />
            </div>
        </PageBody>
    );
};

export default RosterList;
